import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const EXCEPTION_PATHS = ["/public-listing", "/offers/emails"];

function WithDesktopOnly(Component) {
	return function WrappedComponent(props) {
		const { t } = useTranslation();
		const currentPath = window.location.pathname;
		const [width, setWidth] = useState(window.innerWidth);

		useEffect(() => {
			const updateWindowDimensions = () => {
				setWidth(window.innerWidth);
			};

			window.addEventListener("resize", updateWindowDimensions);

			return () => window.removeEventListener("resize", updateWindowDimensions);
		}, []);

		if (width >= 1280 || EXCEPTION_PATHS.includes(currentPath)) {
			return <Component {...props} />;
		} else {
			return (
				<>
					<CssBaseline />
					<Container
						sx={{
							backgroundColor: "#084170",
							height: "100vh",
							display: "flex",
							justifyContent: "center",
							alignItems: "start",
						}}
						maxWidth={false}
					>
						<Typography variant="h5" sx={{ color: "#fff", mt: 6 }}>
							{t("only_desktop_info")}
						</Typography>
					</Container>
				</>
			);
		}
	};
}

export default WithDesktopOnly;
